import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';


// Note: "Fields" is not included in this fragment since it needs to be filtered from outputSteps
export const FlowLineageCountsFragmentGql: DocumentNode = gql`
fragment FlowLineageCountsFragment on Flow {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
